import { useState } from "react";
import { useMutation } from "react-query";
import { TranslateMethod } from "../common/models";
import axios from "axios";

interface IUseSearchQuerySuggestionsProps {
    type: TranslateMethod | undefined
}

const getSuggestedWords = async (searchQuery: string, type: string): Promise<any[]> => {
    return (
        await axios.get("/api/suggested-words/", {
            params: {
                characters: searchQuery,
                search_field: type,
            },
        })
    ).data;
};

export default function useSearchQuerySuggestions(props: IUseSearchQuerySuggestionsProps) {
    const { type } = props;

    // States for suggestions
    const [arabicSuggestions, setArabicSuggestions] = useState<string[]>([]);
    const [romanizationSuggestions, setRomanizationSuggestions] = useState<string[]>([]);

    const {
        isLoading: isLoadingSuggestions,
        mutate: fetchSuggestions,
    } = useMutation<any[],any,string,any>(
        ["suggestion-words", type],
        (searchQuery: string) => {
            console.log("search query : "  + searchQuery)
            return getSuggestedWords(searchQuery, type!.toString());
        },
        {
            onSuccess: (data: any) => {
                if (type == TranslateMethod.Arabic) {
                    setArabicSuggestions(data?.map((x: any) => x.arabic));
                    return;
                }
                setRomanizationSuggestions(data?.map((x: any) => x.arabic_romanization));
                console.log("suggested words : " + JSON.stringify(data));
            },
        }
    );

    return { arabicSuggestions, romanizationSuggestions, fetchSuggestions, isLoadingSuggestions }
}